<template>
  <div>
    <!-- Без дат блок не удаляется, а скрывается: сохраняет место, чтобы не съезжала вёрстка карточки -->
    <div
        class="title-mguu"
        :class="{ 'title-mguu_hidden': !hasDates }"
        :aria-hidden="!hasDates"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="title-mguu_img">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.56405 2C4.84091 2 5.06535 2.19212 5.06535 2.42912V3.23763H10.9386V2.42912C10.9386 2.19212 11.163 2 11.4399 2C11.7167 2 11.9412 2.19212 11.9412 2.42912V3.27115C13.1138 3.45049 14.0039 4.32788 14.0039 5.38322V11.8513C14.0039 13.0363 12.8817 13.9969 11.4974 13.9969H4.50652C3.12221 13.9969 2 13.0363 2 11.8513V5.38322C2 4.32787 2.89011 3.45049 4.06274 3.27115V2.42912C4.06274 2.19212 4.28718 2 4.56405 2ZM4.50653 4.09587C3.67594 4.09587 3.00261 4.67223 3.00261 5.38322V5.71288H13.0013V5.38322C13.0013 4.67223 12.328 4.09587 11.4974 4.09587H4.50653ZM13.0013 6.57112H3.00261V11.8513C3.00261 12.5623 3.67594 13.1386 4.50652 13.1386H11.4974C12.328 13.1386 13.0013 12.5623 13.0013 11.8513V6.57112Z" fill="#12122C"/>
      </svg>
      <span>{{ dateRangeLabel || '\u00A0' }}</span>
    </div>
  </div>
</template>

<script>
import mtSvg from '@/components/UI/mtSvg/index.vue';
import { format, isSameMonth, isSameYear } from 'date-fns';
import { ru } from 'date-fns/locale';

export default {
  name: "planTestTime",
  components: {mtSvg},
  props: {
    item: Object
  },
  computed: {
    hasDates() {
      return Boolean(this.item.dateFrom || this.item.dateTo);
    },
    dateRangeLabel() {
      const from = this.item.dateFromUnformatted;
      const to = this.item.dateToUnformatted;

      if (!from && !to) return '';
      if (!from || !to) {
        return format(new Date(from || to), 'd MMMM', { locale: ru });
      }

      const fromDate = new Date(from);
      const toDate = new Date(to);

      if (isSameMonth(fromDate, toDate) && isSameYear(fromDate, toDate)) {
        return `${format(fromDate, 'd')} – ${format(toDate, 'd MMMM', { locale: ru })}`;
      }

      return `${format(fromDate, 'd MMMM', { locale: ru })} – ${format(toDate, 'd MMMM', { locale: ru })}`;
    }
  }
}
</script>

<style
    lang="scss"
    src="./mguu.scss"
/>